module.exports = __webpack_public_path__ + "img/ded-stock-4.2daa8a01.png";